import { render, staticRenderFns } from "./InputWork.vue?vue&type=template&id=328a8709&"
import script from "./InputWork.vue?vue&type=script&lang=js&"
export * from "./InputWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports